import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type LeaveProgramRouteParams = {
  id: string;
};

export const leaveProgram = async ({ routeParams: { id } }: RouteParamsRequest<LeaveProgramRouteParams>) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.program.join(id));
